import { Facebook, Twitter, Linkedin, Link2, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function ShareBar({ title, url, vertical = false }) {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent(shareUrl);
  const encT = encodeURIComponent(title || "");

  const links = [
    { name: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc}`, color: "#1877F2" },
    { name: "X", icon: Twitter, href: `https://twitter.com/intent/tweet?url=${enc}&text=${encT}`, color: "#0F172A" },
    { name: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${encT}%20${enc}`, color: "#25D366" },
    { name: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}`, color: "#0A66C2" },
  ];

  const copy = () => {
    navigator.clipboard.writeText(shareUrl);
    toast.success("Lien de l'article copié dans le presse-papier");
  };

  return (
    <div className={vertical ? "flex flex-col gap-3" : "flex flex-wrap gap-3 items-center"} data-testid="share-bar">
      {!vertical && <span className="meta-label text-slate-500 mr-1">Partager</span>}
      {links.map((l) => (
        <a key={l.name} href={l.href} target="_blank" rel="noopener noreferrer"
          data-testid={`share-${l.name.toLowerCase()}`}
          className="w-10 h-10 rounded-full flex items-center justify-center text-white hover:scale-110 transition-transform"
          style={{ background: l.color }} aria-label={`Partager sur ${l.name}`}>
          <l.icon size={17} />
        </a>
      ))}
      <button onClick={copy} data-testid="share-copy"
        className="w-10 h-10 rounded-full flex items-center justify-center bg-slate-200 text-slate-700 hover:bg-slate-300 transition-colors" aria-label="Copier le lien">
        <Link2 size={17} />
      </button>
    </div>
  );
}
